module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"menu":{"buyNow":"BESTELLEN","positions":{"offer":"Bieten","about":"Über uns","faq":"FAQ","work":"Karriere","news":"Aktuelles","contact":"Kontakt"},"buyOnline":"Online bestellen"}},"en":{"menu":{"buyNow":"ORDER","positions":{"offer":"Offer","about":"About the company","faq":"FAQ","work":"Careers","news":"News","contact":"Contact"},"buyOnline":"Order online"}}}')
  delete Component.options._Ctor
}
